export const getImgDataIndex = (p, width) => !p ? null : (p.y * width + p.x) * 4;
